export const TEMPLATE_UPLOAD_CAMPAIGN = "TEMPLATE_UPLOAD_CAMPAIGN.xlsx";
